import styled from "styled-components";
import { position } from "polished";
const TokenInputEditWrapper = styled("div")({
  maxWidth: "100%",
  padding: "1px 0",
  position: "relative",
  "&::after": {
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre-wrap"
  }
});
const TokenInputEditImpl = styled("input")(({ theme }) => ({
  border: 0,
  color: theme.color.gray8,
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  lineHeight: theme.lineHeight.default,
  outline: 0,
  padding: 0,
  ...position("absolute", 1, null, null, 0),
  width: "100%",
  "&::placeholder": {
    color: theme.color.gray6,
    lineHeight: theme.lineHeight.default
  }
}));
export {
  TokenInputEditImpl,
  TokenInputEditWrapper
};
